// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3038":"276ff9465e8c9c3d","6025":"f56ea8ac4a703197","7889":"bcc1303008ab43ec","8573":"30a0f5b7ed7806b9"}[chunkId] + ".css";
};